import { createStyles, makeStyles } from '@material-ui/core';

export const useKanbanBoardCardStyles = makeStyles(() =>
    createStyles({
        root: {
            'padding': '0px 12px',
            'cursor': 'grab',
            'overflow': 'hidden',
            'transition': 'all 0.2s ease',
            'position': 'relative',

            '& img': {
                pointerEvents: 'none'
            }
        },
        dragging: {
            opacity: 0.7,
            transform: 'scale(0.95)'
        },
        static: {
            cursor: 'default'
        }
    })
);
